import { useEffect, useRef } from "react";

import { useHistory, useLocation } from "react-router";

import { Button, useModal } from "@alpacahq/ui/old";

import { SuccessGraphic } from "../../../components/SuccessGraphic";

interface LocationState {
  showFpslSuccessModal?: boolean;
}

export const FpslSuccessModal = () => {
  const history = useHistory();
  const location = useLocation<LocationState>();

  const {
    component: SuccessModal,
    toggle: toggleSuccessModal,
    isOpen,
  } = useModal({
    size: "xs",
    title: "",
    onClose: () => {
      history.replace(location.pathname, {});
    },
    controls: (
      <Button
        variant="v2/filled"
        className="w-full bg-yellow-300 text-black hover:bg-yellow-500"
        onClick={() => {
          toggleSuccessModal();
          history.replace(location.pathname, {});
        }}
      >
        Okay
      </Button>
    ),
    content: (
      <div className="flex flex-col items-center gap-4">
        <SuccessGraphic />
        <h1 className="text-2xl text-gray-800">You are in!</h1>
        <div className="flex flex-col items-center gap-1 text-gray-600">
          <span>Your account is active and ready to earn.</span>
          <span>Interest adds up daily and gets paid monthly!</span>
        </div>
      </div>
    ),
    contentClassName: "p-4 m-0",
    panelClassName: "p-0",
  });

  const hasShown = useRef(false);

  useEffect(() => {
    if (location.state?.showFpslSuccessModal && !isOpen && !hasShown.current) {
      hasShown.current = true;
      toggleSuccessModal();
    }
  }, [location.state?.showFpslSuccessModal, isOpen, toggleSuccessModal]);

  return <>{SuccessModal}</>;
};
